"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var label_text_1 = require("../../../primitives/label-text");

var LabelPosition;

(function (LabelPosition) {
  LabelPosition[LabelPosition["above"] = 0] = "above";
  LabelPosition[LabelPosition["left"] = 1] = "left";
  LabelPosition[LabelPosition["right"] = 2] = "right";
})(LabelPosition = exports.LabelPosition || (exports.LabelPosition = {}));

exports.Label = function (props) {
  var position = props.position || LabelPosition.above;
  var viewStyle = getLabelViewStyle(position);
  var textStyle = getLabelTextStyle(position);
  return react_1.default.createElement(label_text_1.LabelText, {
    style: [viewStyle, props.viewStyle]
  }, react_1.default.createElement(react_native_1.Text, {
    style: [textStyle, props.textStyle]
  }, props.label), props.children);

  function getLabelViewStyle(labelPosition) {
    switch (labelPosition) {
      case LabelPosition.left:
        return theme_pricing_system_1.pricingStyles.nativeLabelLeftViewStyle;

      case LabelPosition.right:
        return theme_pricing_system_1.pricingStyles.nativeLabelRightViewStyle;

      default:
        return theme_pricing_system_1.pricingStyles.nativeLabelAboveViewStyle;
    }
  }

  function getLabelTextStyle(labelPostion) {
    switch (labelPostion) {
      case LabelPosition.right:
        return theme_pricing_system_1.pricingStyles.nativeLabelRightTextStyle;

      case LabelPosition.left:
        return theme_pricing_system_1.pricingStyles.nativeLabelLeftTextStyle;

      default:
        return theme_pricing_system_1.pricingStyles.nativeLabelAboveTextStyle;
    }
  }
};